// Scope and budget ranges supplied by Michael in Blue / August 30 email.
export const PROJECT_LANDINGS = {
  roofing: {
    name: 'Roofing',
    headline: 'A complete roof. A clear plan.',
    intro: 'Replacing a roof or building a new home? Tell us about your property and MRE will help you plan the next step.',
    image: '/projects/roofing.jpg',
    imageAlt: 'MRE residential roofing project',
    service: 'roofing',
    selectionField: 'scope',
    sectionTitle: 'Four complete-job services.',
    selectionLabel: 'What roofing project are you planning?',
    options: [
      'Single-family home roof replacement',
      'Multi-family home roof replacement',
      'New single-family home roof installation',
      'New multi-family home roof installation',
    ],
    note: 'This enquiry is for complete residential roof replacements and new roof installations. Small repairs are outside this offering.',
    questions: [
      { q: 'Which roofing projects can I enquire about?', a: 'Choose from four complete-job services: roof replacement or a new roof installation, for either a single-family or multi-family residential property.' },
      { q: 'Can I get a price before you see the property?', a: 'Share the property type, location and planned timing. MRE will review the scope and any site information needed before providing a project-specific quote.' },
      { q: 'Where does MRE work?', a: 'Our construction team serves Calgary and the surrounding region. Include your community so we can confirm availability for your project.' },
    ],
  },
  'full-home-renovations': {
    name: 'Full Home Renovations',
    headline: 'Your whole home. Thought through.',
    intro: 'Plan a full-house renovation with a clear starting budget, a considered scope and one conversation about what matters to you.',
    image: '/projects/full-reno.jpg',
    imageAlt: 'Completed MRE home renovation',
    service: 'home-renovations',
    selectionField: 'budget',
    scope: 'Full-house renovation',
    sectionTitle: 'Start with your investment.',
    selectionLabel: 'What is your planned renovation budget?',
    options: ['$100,000–$200,000', '$200,000–$300,000', '$300,000–$400,000', '$400,000–$500,000', '$500,000+'],
    note: 'Budget ranges are in CAD and help us understand your plans. They are not fixed prices or quotes; final pricing depends on your scope, finishes and site conditions.',
    questions: [
      { q: 'What budget should I select?', a: 'Choose the range closest to your planned investment, from $100,000–$200,000 through $500,000+. These are planning ranges, not fixed-price packages. We will discuss the scope before quoting.' },
      { q: 'Do I need finished drawings to get in touch?', a: 'Tell us what you already have and what you want to change. That gives the team a starting point for discussing design, scope and the next steps.' },
      { q: 'Is this suitable for small repairs?', a: 'This enquiry is for substantial full-house renovations starting with a planned budget of $100,000. It is not a small-repair or handyman offering.' },
    ],
  },
  'bathroom-renovations': {
    name: 'Bathroom Renovations',
    headline: 'A better bathroom. A clear budget.',
    intro: 'Planning an ensuite or main bathroom renovation? Choose a starting budget and tell us about your space. MRE will help you plan the scope and the next step.',
    image: '/projects/bathroom-test-1.webp',
    imageAlt: 'Bathroom renovated by MRE Developments in Calgary',
    service: 'bathroom-renovations',
    selectionField: 'budget',
    scope: 'Bathroom renovation',
    sectionTitle: 'Start with your investment.',
    selectionLabel: 'What is your planned bathroom budget?',
    options: ['$7,500–$15,000', '$15,000–$25,000', '$25,000–$50,000'],
    note: 'Budget ranges are in CAD and help us understand your plans. They are not fixed prices or quotes; final pricing depends on your scope, finishes and site conditions.',
    questions: [
      { q: 'What does each budget range cover?', a: 'The ranges reflect three levels of residential bathroom renovation, from refreshed finishes and fixtures through to full ensuite rebuilds with custom showers and tile. We confirm what your budget covers after discussing your space and finishes.' },
      { q: 'Do you handle the plumbing, tile and waterproofing?', a: 'Yes. MRE manages the whole renovation, including demolition, plumbing, waterproofing, tile and fixture installation, so you have one team accountable for the result.' },
      { q: 'Where does MRE work?', a: 'Our construction team serves Calgary and the surrounding region. Include your community so we can confirm availability for your project.' },
    ],
  },
};

export function buildProjectLead(slug, form, search = '') {
  const page = PROJECT_LANDINGS[slug];
  if (!page || !page.options.includes(form.selection)) throw new Error('Choose a project option.');
  const params = new URLSearchParams(search);
  const campaign = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']
    .filter(key => params.has(key))
    .map(key => `${key}: ${params.get(key).replace(/[\r\n]/g, ' ').slice(0, 150)}`);
  return {
    name: form.name.trim(), email: form.email.trim(), phone: form.phone.trim(),
    track: 'build', project_type: page.name,
    scope: page.selectionField === 'scope' ? form.selection : page.scope,
    budget: page.selectionField === 'budget' ? form.selection : '',
    timeline: form.timeline,
    source: `landing_${slug.replace(/-/g, '_')}`,
    message: [`Community / postal code: ${form.location.trim()}`, form.message.trim(), ...campaign].filter(Boolean).join('\n'),
    company_website: form.company_website, fax: '',
  };
}
